import type { CSSProperties } from 'react';
import classNames from 'classnames';
import styles from './FJLoading.module.less';

interface FJLoadingProps {
    strokeColor?: string;
    style?: CSSProperties;
    className?: string;
}

export default function FJLoading({ strokeColor = '#fff', style = {}, className }: FJLoadingProps) {
    const width = style.width ?? 20;
    const height = style.height ?? 20;
    return (
        <svg
            viewBox='0 0 50 50'
            className={classNames(styles.svg_load, className)}
            style={{ width, height, ...style }}
        >
            <circle cx='25' cy='25' r={25} stroke={strokeColor} fill='none' className={styles.svg_loading} />
        </svg>
    );
}
